import React from 'react';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router';

import {Group, Menu} from '@mantine/core';
import {faChevronDown} from '@fortawesome/pro-solid-svg-icons';
import {isHangryAppMenuPath, MENU_ROUTE_BASE_PATHS} from 'utils/menuAvailability';

// Local styles
import {useStyles} from './styles';
import FaDisplay from 'components/others/FaDisplay';
import Text from 'components/core/Text';

const NavMenu = ({availableMenus}) => {
	const {classes, cx} = useStyles();
	const location = useLocation();
	const isPathActive = pathname => location.pathname === pathname || location.pathname.startsWith(`${pathname}/`);
	const isOptionActive = option => isPathActive(option.pathname)
		&& !(option.pathname === MENU_ROUTE_BASE_PATHS.RAYQUAZA && isHangryAppMenuPath(location.pathname));

	return (
		<Group spacing={8}>
			{availableMenus.map((menu, index) => {
				const isActive = menu.options?.length
					? menu.options.some(isOptionActive)
					: isPathActive(menu.pathname);

				if (menu.options?.length) {
					return (
						<Menu
							key={index}
							withinPortal
							placement='start'
							gutter={8}
							classNames={{
								dropdown: classes.dropdownBody,
								item: classes.dropdownItem,
							}}
							control={(
								<button
									type="button"
									aria-haspopup="menu"
									className={cx(classes.buttonContainer, isActive && classes.buttonContainerActive)}>
									<FaDisplay
										faProps={{spin: menu.spin}}
										containerSize={18}
										fontSize={14}
										faIcon={menu.icon}
									/>
									<Text typography='title-bold-16'>{menu.label}</Text>
									<FaDisplay
										containerSize={14}
										fontSize={12}
										faIcon={faChevronDown}
									/>
								</button>
							)}>
							{menu.options.map(option => (
								<Menu.Item
									key={option.pathname}
									onClick={option.onClick}
									className={cx(isOptionActive(option) && classes.dropdownItemActive)}>
									<Text typography="subtitle-medium-14">{option.label}</Text>
								</Menu.Item>
							))}
						</Menu>
					);
				}

				return (
					<Group
						onClick={menu.onClick}
						className={cx(classes.buttonContainer, isActive && classes.buttonContainerActive)}
						key={index}
						spacing={4}>
						<FaDisplay
							faProps={{spin: menu.spin}}
							containerSize={18}
							fontSize={14}
							faIcon={menu.icon}
						/>
						<Text typography='title-bold-16'>{menu.label}</Text>
					</Group>
				);
			})}
		</Group>
	);
};

NavMenu.defaultProps = {
	availableMenus: [],
};

NavMenu.propTypes = {
	availableMenus: PropTypes.array,
};

export default NavMenu;
